let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = Promise.all([load("ffQaD"), load("kvRbA"), load("fliVL"), load("bu4VX")]).then(() => parcelRequire('kG5x5'));